import styled from "styled-components";

export const Wrapper = styled.main`
  width: 100%;
  height: 100%;
  background: radial-gradient(circle,rgba(20, 149, 255, 0.1), #080808 75%);

  @media only screen and (min-width: 800px) {
    background: radial-gradient(circle,rgba(20, 149, 255, 0.1), #080808 60%);
  }

  @media only screen and (min-width: 943px) {
    background: radial-gradient(circle,rgba(20, 149, 255, 0.1), #080808 55%);
  }
`;

export const JoinOurCommunityContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 60px 20px;

  @media only screen and (min-width: 600px) {
    padding-left: 40px;
    padding-right: 40px;
  }

  @media only screen and (min-width: 700px) {
    padding: 60px;
  }

  @media only screen and (min-width: 800px) {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  @media only screen and (min-width: 943px) {
    padding-top: 120px;
    padding-bottom: 120px;
  }

  /* border: 0.5px solid yellow; */
`;

export const Title = styled.p`
  width: 100%;
  height: fit-content;
  text-align: center;
  font-size: 36px;
  font-weight: 500;
  line-height: 115%;
  color: #ebebeb;
  margin-bottom: 28px;

  @media only screen and (min-width: 400px) {
    margin-bottom: 36px;
  }

  @media only screen and (min-width: 500px) {
    margin-bottom: 44px;
  }

  @media only screen and (min-width: 600px) {
    margin-bottom: 52px;
  }

  @media only screen and (min-width: 700px) {
    margin-bottom: 60px;
  }

  /* border: 0.5px solid gray; */
`;

export const HighlightedText = styled.span`
  width: fit-content;
  height: fit-content;
  font-size: 36px;
  font-weight: 500;
  line-height: 115%;
  color: transparent;
  background: linear-gradient(to right, #39ff71, #00fff0);
  -webkit-background-clip: text;
`;

export const SocialButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: fit-content;

  @media only screen and (min-width: 625px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  @media only screen and (min-width: 1220px) {
    width: 900px;
  }

  /* border: 0.5px solid gray; */
`;

export const SocialButton = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 263px;
  height: fit-content;
  background:rgba(8, 8, 8, 0.65);
  border: 2px solid #39ff71;
  border-radius: 6px;
  padding: 12px 16px;
  cursor: pointer;

  &:hover {
    background:rgba(20, 149, 255, 0.06);
  }
`;

export const SocialIcon = styled.img.attrs(() => ({
  loading: "lazy",
  draggable: false,
}))`
  width: 28px;
  height: 28px;
`;

export const SocialText = styled.p`
  width: fit-content;
  height: fit-content;
  font-size: 16px;
`;
